import React from 'react';
import {
  Typography,
  Grid,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { motion } from 'framer-motion';
import { products } from '../../data/products';
import PageLayout from '../../components/PageLayout';
import ProductCard from '../../components/ProductCard';

const PageTitle = styled(Typography)({
  fontFamily: 'Cormorant Garamond, serif',
  fontSize: '2.5rem',
  color: '#1a1a1a',
  marginBottom: '1rem',
  textAlign: 'center',
});

const WatchesPage = () => {
  // Filter watches from high-jewelry category that have "watch" in their name or description
  const watchProducts = products.filter(product => 
    product.category === 'high-jewelry' && 
    (product.name.toLowerCase().includes('watch') || 
     product.description.toLowerCase().includes('watch'))
  );

  return (
    <PageLayout>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <PageTitle>Luxury Timepieces</PageTitle>
        <Typography
          variant="subtitle1"
          color="textSecondary"
          align="center"
          sx={{ mb: 6 }}
        >
          Discover our curated collection of prestigious timepieces, featuring exceptional craftsmanship and timeless elegance
        </Typography>

        <Grid container spacing={4}>
          {watchProducts.map((product) => (
            <Grid item key={product.id} xs={12} sm={6} md={4}>
              <ProductCard product={product} />
            </Grid>
          ))}
        </Grid>

        {watchProducts.length === 0 && (
          <Typography
            variant="h6"
            color="textSecondary"
            align="center"
            sx={{ mt: 4 }}
          >
            New timepieces coming soon
          </Typography>
        )}
      </motion.div>
    </PageLayout>
  );
};

export default WatchesPage;
